import pick from "lodash/pick";
import constans from "../Common/Constants";
import { havePermission } from "../../permissions";
import LAYERS_PERMISSIONS from "../../permissions/Layers.json";
import { selectedPolygonTypes } from "../Common/Constants";
import Functions from "../Common/Functions";
import { isEmpty } from "lodash";

const { SecColors } = constans;
const { getLegend } = Functions;

const { sec_density } = selectedPolygonTypes;

const getAllSecs = ({ data }) => {
	if (isEmpty(data)) return [];
	let allSecs = [];
	for (let polygon of data) {
		const { sec } = polygon;
		if (!allSecs.includes(sec)) allSecs.push(sec);
	}
	allSecs = Array.from(new Set([...allSecs])).filter(Boolean);
	return allSecs;
};

const getSecLegends = ({ data, legendHandler }) => {
	if (!havePermission(LAYERS_PERMISSIONS.LAYER_SEC_DENSITY_LEGEND)) return {};

	let legends = [];
	let allSec = [];
	if (isEmpty(allSec) && !isEmpty(data)) {
		allSec = getAllSecs({ data });

		if (isEmpty(allSec)) {
			return { legends: [] };
		}
	}
	allSec = allSec.sort((a, b) => a.localeCompare(b));
	allSec.forEach(value => {
		legends.push(
			getLegend({
				text: `SEC ${value}`,
				color: SecColors[value],
				onClick: () => {
					legendHandler(value);
				}
			})
		);
	});
	legends = legends.sort((a, b) => a.text - b.text);

	return { legends };
};
const getSecDensityPolygons = locations => {
	return {
		polygons: locations.map((obj, ind) => {
			const { sec, population, motor_sports_population } = obj;
			return {
				id: ind,
				_id: ind,
				coordinates: obj.coordinates,
				style: {
					fillColor: SecColors[sec],
					strokeColor: "#00000055",
					zindex: 10
				},
				filterData: { sec, population, motor_sports_population },
				polygonClick: true,
				type: sec_density
			};
		})
	};
};

const SecDensityService = {
	all: ({ locations, legendHandler }) => {
		return {
			...pick(getSecDensityPolygons(locations), ["polygons"]),
			...getSecLegends({ data: locations, legendHandler })
		};
	},
	polygons: ({ locations }) => {
		return pick(getSecDensityPolygons(locations), ["polygons"]);
	}
};

export default SecDensityService;
export { getSecDensityPolygons };
